import { Reducer } from 'redux';
import { ManufacturerType } from "models/ManufacturerType";
import { IManufacturerTypeActions, ManufacturerTypeActionType } from "redux/actions/settings/ManufacturerTypeActions";

const initialState: ManufacturerType[] | null = null;
export const manufacturerTypesReducer: Reducer<ManufacturerType[] | null, IManufacturerTypeActions> =
    (state = initialState, action) => {
        switch (action.type) {
            case ManufacturerTypeActionType.FETCH_MANUFACTURERTYPES_SUCCESS:
                {
                    return action.returnPayload as ManufacturerType[];
                }
            default:
                return state;
        }
    };
